import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Heart(props: IconProps) {
  return (
    <IconSvg {...props} viewBox="0 0 44 44">
      <path d="M21.836 40.703l17.88-17.894c4.932-5.046 5.088-13.058.354-18.291-4.733-5.233-12.721-5.88-18.234-1.476C16.317-1.499 8.2-.889 3.423 4.425-1.355 9.74-1.101 17.875 4 22.881l17.836 17.822z"></path>
    </IconSvg>
  );
}
